import React, { Component } from 'react';
import ResultComponent from '../components/Result'
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

class Result extends Component {

    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            primaryStyle: null,
            secondaryStyle: null
        };
    }

    componentWillMount = () => {
        debugger
        if (this.props.selectionResult)
            this.processSelection(this.props.selectionResult)
        else
            this.props.history.push('/style/')
    }

    processSelection(selection) {
        let items = []
        debugger
        for (const key in selection) {
            let style = this.props.styles.find((i) => i.ID === Number(key))
            items.push({ style: Number(key), count: selection[key], priority: style.PRIORITY })
        }
        items.sort(function (item1, item2) {
            if (item1.count > item2.count) return -1
            else if (item2.count > item1.count) return 1
            else {
                if (item1.priority < item2.priority) return -1
                else if (item2.priority < item1.priority) return 1
            }
            return 0
        })

        this.setState({ primaryStyle: this.props.styles.find((i) => i.ID === items[0].style), secondaryStyle: this.props.styles.find((i) => i.ID === items[1].style) })
    }

    render() {
        return (
            <ResultComponent history={this.props.history} primaryStyle={this.state.primaryStyle} secondaryStyle={this.state.secondaryStyle} cssOpen={this.props.cssOpen} />
        );
    }
}

const mapStateProps = (state) => {
    return {
        styles: state.ImagesReducer.styles,
        selectionResult: state.SettingsReducer.selectionResult,
        cssOpen: state.SettingsReducer.cssOpen
    }
}

export default withRouter(connect(mapStateProps, {})(Result));